export default "__VITE_ASSET__DiDnJ$la__"